<template>
  <div class="wrapper">
    <div class="main-info">      
      <MemberCard :info="groupInfo" />
      <MemberTable class="member-table" :infoList="memberInfoList" @itemClick="itemClick" :source="source"
      @handlerChange="handlerChange"
      />
    </div>   
     
    <div class="total-auth-btn" @click="totalClick" 
    v-if="(memberInfoList.find(v=>v.authorizationStatus=='UN_AUTH')&&
    memberInfoList.find(v=>v.authorizationStatus=='UN_AUTH')['customers'].length>1)
    &&['UN_AUTH'].includes(authorizationStatues)">全部授权</div>   
 
  </div>
</template>

<script>
import { MemberTable, MemberCard } from './components'
import { fetchNoAuthGroupList,fetchAuthGroupList, changeNoAuthGroupItemStatus,changeAuthGroupItemStatus } from '@/services/api.index'
export default {
  name: 'MemberAuth',
  components: {
    MemberTable,
    MemberCard
  },
  data() {
    return {
      authorizationStatues:'UN_AUTH',
      groupId: '',
      source:'',//网页跳转来源
      groupInfo: {},
      memberInfoList: []
    }
  },
  created() {
    const { id,source} = this.$route.query
    this.groupId = id    
    this.source=source==undefined?'SMS':source.toLocaleUpperCase();    
    this.getGroupList()

  },
  methods: {
    handlerChange(val){      
      this.authorizationStatues=val.value;
      // this.getGroupList(val.value)
    },
    async getGroupList() {
      // const { data } = await fetchNoAuthGroupList(this.groupId)
      const { data } = await fetchAuthGroupList(this.groupId)      
      const { headName, groupName,leaderName,customers } = data
      // this.memberInfoList = data.members
      this.memberInfoList = data.groupByAuthStatusCustomers;      
      this.groupInfo = {
        groupName,
        headName,
        leaderName,
        customers,
      }
    },
    async itemClick(id,authorizationStatus,authorizationType,currentAuthorizationStatus) {      
      let confirmStr=authorizationStatus=='CANCEL'?'是否确认对该成员进行取消授权操作':'是否确认为该成员进行授权';
      await this.$confirm(confirmStr, '', {
        customClass: '_share-message-box'
      })
      this.updateGroupStatus([id],authorizationStatus,authorizationType,currentAuthorizationStatus)
    },
    async totalClick() {
      await this.$confirm('是否确认进行全部授权操作', '', {
        customClass: '_share-message-box'
      })      
      let UN_AUTHObj=this.memberInfoList.find(v=>v.authorizationStatus=='UN_AUTH')||{};
      let idList = UN_AUTHObj['customers'].map(({ id }) => id);       
      this.updateGroupStatus(idList,'AUTHED',this.source,'UN_AUTH')
    },
    async updateGroupStatus(list,authorizationStatus,authorizationType,currentAuthorizationStatus) {
      let params={
        customerIds:list,
        authorizationStatus:authorizationStatus,//修改后授权状态
        authorizationType:authorizationType,//授权方式
        currentAuthorizationStatus:currentAuthorizationStatus//当前条目授权状态
      }
      // await changeNoAuthGroupItemStatus(this.groupId, list)
      // await changeAuthGroupItemStatus(this.groupId, params)
      changeAuthGroupItemStatus(this.groupId, params).then(()=>{
        let mes=authorizationStatus=='CANCEL'?'取消授权成功':'授权成功';
          this.$message.success(mes)
          this.getGroupList()
      }).catch(()=>{        
        this.getGroupList()
      })      
      
      
    }
  }
}
</script>

<style>
._share-message-box {
  width: 280px;
}
</style>

<style lang="scss" scoped>
.wrapper {
  padding: 15px;
  padding-bottom: calc(15px + 20px);
  min-height: 90vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .member-table {
    margin-top: 10px;
    margin-bottom: 20px;
  }
  .total-auth-btn {
    position: fixed;
    bottom: 0;
    width: calc(100% - 30px);
    height: 40px;
    line-height: 40px;
    border-radius: 40px;
    font-weight: 600;
    font-size: 14px;
    text-align: center;
    color: #fff;
    background-color: #1e4998;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/share/member-auth/index.vue